import { initializeCarousel } from '../../scripts/carousel';
import { disableBodyScroll, enableBodyScroll, trapFocus } from '../../scripts/utils';
import { initializeVideos } from '../video/video';

const modalClass = 'c-modal';
const modalOpenClass = modalClass + '--open';

const modalJsClass = 'js-modal';
const buttonCloseJsClass = modalJsClass + '-button-close';
const contentJsClass = modalJsClass + '-content';

const carouselJsClass = 'js-carousel';

const modalElement = document.querySelector('.' + modalJsClass) as HTMLDialogElement;
const buttonCloseElement = document.querySelector('.' + buttonCloseJsClass) as HTMLButtonElement;
const contentElement = document.querySelector('.' + contentJsClass) as HTMLElement;

let requestElement: HTMLElement; // Reference to the element that opened the modal

if (modalElement && buttonCloseElement) {
    // Add a click event listener to the close button
    buttonCloseElement.addEventListener('click', () => {
        closeModal();
    });

    // Add a keydown event listener
    modalElement.addEventListener('keydown', (event) => {
        // If the escape key is pressed
        if (
            event.key === 'Escape'
            && !event.ctrlKey
            && !event.altKey
            && !event.metaKey
            && !event.shiftKey
        ) {
            // Close the modal
            closeModal();
        }
    });
}

export async function openModal (
    element: HTMLElement,
    initialSlide = 0,
    url: string,
    ariaLabelledby: string
): Promise<void> {
    if (
        !element
        || !url
        || !modalElement
        || !buttonCloseElement
        || !contentElement
    ) {
        return;
    }

    try {
        // Set request element
        requestElement = element;

        // Fetch markup
        const response = await fetch(url);

        // Get markup from response
        const markup = await response.text();

        // Add markup to modal
        contentElement.innerHTML = markup;

        // Disable body scroll
        disableBodyScroll();

        // Add aria-labelledby
        if (ariaLabelledby) {
            modalElement.setAttribute('aria-labelledby', ariaLabelledby);
        }

        // Open modal
        modalElement.classList.add(modalOpenClass);

        // Update the inert property to allow focus
        modalElement.inert = false;

        // Set focus on close button
        buttonCloseElement.focus();

        // Trap focus in modal
        trapFocus(modalElement);

        // Get carousel element
        const carouselElement = modalElement.querySelector('.' + carouselJsClass) as HTMLElement;

        if (carouselElement) {
            // Init Swiper
            initializeCarousel(carouselElement, initialSlide);

            // Init videos
            initializeVideos();
        }
    } catch (error) {
        console.error(error);

        // Reset request element
        requestElement = null;
    }
}

export function closeModal (): void {
    if (!modalElement || !contentElement) {
        return;
    }

    // Enable body scroll
    enableBodyScroll();

    // Remove aria-labelledby
    modalElement.setAttribute('aria-labelledby', '');

    // Close modal
    modalElement.classList.remove(modalOpenClass);

    // Update the inert property to prevent focus
    modalElement.inert = true;

    // Remove markup from modal
    contentElement.innerHTML = '';

    // Set focus back to element that opened the modal
    if (requestElement) {
        requestElement.focus();
    }

    // Reset request element
    requestElement = null;
}